import * as React from 'react';
import OktaEnroll from './OktaEnroll';
import { IOktaMfaModel, IOktaMfaEvent } from './Model';

interface IOktaSetupProps {
    okta: IOktaMfaModel;
    onClick: () => void;
    callback: (event: IOktaMfaEvent) => void;
    enrollState: {
        isEnrollSelected: boolean;
        enrollFactor: string;
    };
}

/*
 * This component will be used during enrollment process where
 * user is shown multiple factors to enroll into. Every Factor
 * will have its setup component
 */
class OktaSetup extends React.Component<IOktaSetupProps> {
    render() {
        const { state, strings } = this.props.okta.oktaMfa;
        const setUpPageTitle = strings.factorEnrollmentTitle.replace('[FACTOR_NAME]', strings.oktaVerifyFactor);
        let setupPage;

        const hasTotp = state.factorsForEnrollment.indexOf('okta_totp') != -1;
        const hasPush = state.factorsForEnrollment.indexOf('okta_push') != -1;

        if (this.props.enrollState.isEnrollSelected && (hasTotp || hasPush)) {
            setupPage = (
                <div>
                    <h3>{setUpPageTitle}</h3>
                    <OktaEnroll okta={this.props.okta} callback={this.props.callback} />
                </div>
            );
        } else {
            let val = strings.oktaVerifyFactor;
            let disable = false;
            if (!hasTotp) {
                if (!hasPush) {
                    val = strings.enrolledFactor.replace('[FACTOR_NAME]', strings.oktaVerifyFactor);
                    disable = true;
                } else {
                    val = strings.oktaVerifyUpgrade;
                }
            }
            const btnClass = disable
                ? 'apmui-button apmui-button-submit apmui-button-long apmui-button-disabled'
                : 'apmui-button apmui-button-submit apmui-button-long';
            setupPage = (
                <div>
                    <span className="button-container">
                        <input
                            type="submit"
                            className={btnClass}
                            value={val}
                            disabled={disable}
                            onClick={this.props.onClick}
                        />
                    </span>
                </div>
            );
        }
        return <div>{setupPage}</div>;
    }
}

export default OktaSetup;
